module.exports = __webpack_public_path__ + "static/media/Sidebar-expenses-icon-active.9126a873.svg";